import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import type { SetStateAction } from 'react'
import { FormattedMessage } from 'react-intl'

import type { AvailableColumn } from '../types'
import messages from './messages'
import * as S from './styles'

interface ColumnPickerDynamicColumnsProps {
  dynamicColumns?: AvailableColumn[] | null | undefined
  setExpanded: (value: SetStateAction<boolean>) => void
  onToggle: (id: string) => void
}

export const ColumnPickerDynamicColumns = ({
  dynamicColumns,
  setExpanded,
  onToggle,
}: ColumnPickerDynamicColumnsProps) => (
  <Box data-test-id="dynamic-col-container">
    <S.DynamicColumnsHeader>
      <Typography variant="caption" color="textSecondary">
        <FormattedMessage {...messages.custom} />
      </Typography>
      <IconButton size="small" onClick={() => setExpanded(true)} data-test-id="open-dynamic-search">
        <AddIcon fontSize="small" />
      </IconButton>
    </S.DynamicColumnsHeader>
    {dynamicColumns
      ?.filter((column) => !!column.metaGroup)
      .map((column) => (
        <S.DynamicColumnRow key={column.id}>
          <IconButton
            onClick={() => onToggle(column.id)}
            data-test-id={`remove-dynamic-col-button-${column.title}`}
            size="small"
            sx={{ height: 20, width: 20 }}
          >
            <RemoveIcon fontSize="small" />
          </IconButton>
          <Typography
            variant="body2"
            color="textSecondary"
            noWrap
          >{`${column.metaGroup} /`}</Typography>
          <Typography
            variant="body2"
            color="textPrimary"
            noWrap
            data-test-id={`column-name-${column.title}`}
          >
            {column.pickerTitle ?? column.title}
          </Typography>
        </S.DynamicColumnRow>
      ))}
  </Box>
)
